import { Injectable } from '@angular/core';
import { ThemeConfig } from '../config/theme.config';
import { environment } from 'src/environments/environment';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  static themeProperty = 'consoleTheme';

  themeConfig = ThemeConfig;

  themes = [ 'light', 'dark', 'dpg' ];
  defaultTheme = 'dark';
  changeListeners = [] as Subject<any>[];

  constructor(
  ) {
  }

  public getTheme(): string {
    if (!localStorage.getItem(ThemeService.themeProperty)) {
      return environment.serviceTheme;
    } else {
      return localStorage.getItem(ThemeService.themeProperty);
    }
  }

  public getThemeColors(): any {
    const theme = localStorage.getItem(ThemeService.themeProperty);
    const currentThemeColors = this.themeConfig[theme];

    return currentThemeColors;
  }

  public changed(): Observable<any> {
    const subject = new Subject<any>();

    this.changeListeners.push(subject);
    return subject;
  }

  public changeTheme(theme: string) {
    localStorage.setItem(ThemeService.themeProperty, theme);

    if (this.themeConfig[theme]) {
      const currentTheme = this.themeConfig[theme];

      document.documentElement.style.setProperty('--mainColor', currentTheme.mainColor);
      document.documentElement.style.setProperty('--contentColor', currentTheme.contentColor);
      document.documentElement.style.setProperty('--fontColor', currentTheme.fontColor);
      document.documentElement.style.setProperty('--underlineColor', currentTheme.underlineColor);
      document.documentElement.style.setProperty('--pointColor', currentTheme.pointColor);
      document.documentElement.style.setProperty('--borderColor', currentTheme.borderColor);
      document.documentElement.style.setProperty('--gridColor', currentTheme.gridColor);
      document.documentElement.style.setProperty('--gridBackgroundColor', currentTheme.gridBackgroundColor);
      document.documentElement.style.setProperty('--gridItemColor', currentTheme.gridItemColor);
      document.documentElement.style.setProperty('--gridMapColor', currentTheme.gridMapColor);
      document.documentElement.style.setProperty('--hoverColor', currentTheme.hoverColor);
      document.documentElement.style.setProperty('--hoverFontColor', currentTheme.hoverFontColor);
      document.documentElement.style.setProperty('--buttonColor', currentTheme.buttonColor);
      document.documentElement.style.setProperty('--impactColor', currentTheme.impactColor);
      document.documentElement.style.setProperty('--menuHoverColor', currentTheme.menuHoverColor);

      document.documentElement.style.setProperty('--headerTextColor', currentTheme.headerTextColor);
      document.documentElement.style.setProperty('--headerBackgroundColor', currentTheme.headerBackgroundColor);

      document.documentElement.style.setProperty('--navigationFontColor', currentTheme.navigationFontColor);

      document.documentElement.style.setProperty('--tableThFontColor', currentTheme.tableThFontColor);
      document.documentElement.style.setProperty('--tableThBackgroundColor', currentTheme.tableThBackgroundColor);
      document.documentElement.style.setProperty('--tableHoverFontColor', currentTheme.tableHoverFontColor);
      document.documentElement.style.setProperty('--tableHoverBackgroundColor', currentTheme.tableHoverBackgroundColor);

      document.documentElement.style.setProperty('--toolbarBackgroundColor', currentTheme.toolbarBackgroundColor);
      document.documentElement.style.setProperty('--toolbarColor', currentTheme.toolbarColor);
      document.documentElement.style.setProperty('--toolbarSelectionColor', currentTheme.toolbarSelectionColor);
      document.documentElement.style.setProperty('--toolbarSelectionBackgroundColor', currentTheme.toolbarSelectionBackgroundColor);

      document.documentElement.style.setProperty('--sidepopupBackgroundColor', currentTheme.sidepopupBackgroundColor);
      document.documentElement.style.setProperty('--sidepopupHoverBackgroundColor', currentTheme.sidepopupHoverBackgroundColor);
      document.documentElement.style.setProperty('--sidepopupFontColor', currentTheme.sidepopupFontColor);
      document.documentElement.style.setProperty('--sidemenuBackgroundColor', currentTheme.sidemenuBackgroundColor);
      document.documentElement.style.setProperty('--sidemenuHoverBackgroundColor', currentTheme.sidemenuHoverBackgroundColor);

      document.documentElement.style.setProperty('--dropdownMenuFontColor', currentTheme.dropdownMenuFontColor);
      document.documentElement.style.setProperty('--dropdownMenuHoverFontColor', currentTheme.dropdownMenuHoverFontColor);

      document.documentElement.style.setProperty('--selectedStateColor', currentTheme.selectedStateColor);
      document.documentElement.style.setProperty('--abnormalStateColor', currentTheme.abnormalStateColor);
      document.documentElement.style.setProperty('--incompleteStateColor', currentTheme.incompleteStateColor);
      document.documentElement.style.setProperty('--progressStateColor', currentTheme.progressStateColor);
      document.documentElement.style.setProperty('--completedStateColor', currentTheme.completedStateColor);

      document.documentElement.style.setProperty('--workflowBackground', currentTheme.workflowBackground);
      document.documentElement.style.setProperty('--workflowGrid', currentTheme.workflowGrid);

      document.documentElement.style.setProperty('--normalBorder', currentTheme.normalBorder);
      document.documentElement.style.setProperty('--startBorder', currentTheme.startBorder);
      document.documentElement.style.setProperty('--normalSelect', currentTheme.normalSelect);
      document.documentElement.style.setProperty('--startSelect', currentTheme.startSelect);
      document.documentElement.style.setProperty('--normalText', currentTheme.normalText);
      document.documentElement.style.setProperty('--startSelectText', currentTheme.startSelectText);
      document.documentElement.style.setProperty('--normalSelectText', currentTheme.normalSelectText);
      document.documentElement.style.setProperty('--normalBackground', currentTheme.normalBackground);
      document.documentElement.style.setProperty('--chainSelect', currentTheme.chainSelect);
      document.documentElement.style.setProperty('--chainBackground', currentTheme.chainBackground);

      document.documentElement.style.setProperty('--stateDangerColor', currentTheme.stateDangerColor);
      document.documentElement.style.setProperty('--stateCriticalColor', currentTheme.stateCriticalColor);
      document.documentElement.style.setProperty('--stateWarningColor', currentTheme.stateWarningColor);
      document.documentElement.style.setProperty('--stateMinorColor', currentTheme.stateMinorColor);
      document.documentElement.style.setProperty('--stateIndeterminateColor', currentTheme.stateIndeterminateColor);
      document.documentElement.style.setProperty('--stateSuccessColor', currentTheme.stateSuccessColor);
      document.documentElement.style.setProperty('--statePrimaryColor', currentTheme.statePrimaryColor);

      document.documentElement.style.setProperty('--managerHeaderBackground', currentTheme.managerHeaderBackground);
      document.documentElement.style.setProperty('--managerBackground', currentTheme.managerBackground);

      document.documentElement.style.setProperty('--readonlyInputColor', currentTheme.readonlyInputColor);
      document.documentElement.style.setProperty('--readonlyInputBackgroundColor', currentTheme.readonlyInputBackgroundColor);

      document.documentElement.style.setProperty('--oddCommentBackgroundColor', currentTheme.oddCommentBackgroundColor);

      document.documentElement.style.setProperty('--titleBorderColor', currentTheme.titleBorderColor);

      this.changeListeners.forEach((listener: Subject<any>) => {
        listener.next(theme);
      });
    } else {
      console.log('Invalid theme(' + theme + ') was set !!!');
    }
  }
}
